export enum Market {
  Forex = 'Forex',
  Stocks = 'Stocks',
  Cryptos = 'Cryptos',
  Commodities = 'Commodities',
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/Market.ts